import { getFormValues } from 'redux-form';
import { createSelector } from 'reselect';

import { LotsFilterForm } from '../../../routes/Lots/shared/LotsFilter/LotsFilter';
import { Forms } from '../../form/form.selector';
import { RootState } from '../../reducers';
import { Lot } from './lots.types';

export const getLots = (state: RootState): Lot[] => state.entities.lots;

const filterLots = (lots: Lot[], formValue: LotsFilterForm) => {
  if (!formValue) return lots;

  let filteredLots = lots;
  if (formValue.hideClosed) {
    filteredLots = filteredLots.filter((lot) => !lot.endDate);
  }
  if (formValue.lotType !== '-1') {
    filteredLots = filteredLots.filter((lot) => lot.lotTypeId === formValue.lotType);
  }
  const search = formValue.lotName?.trim().toLowerCase();
  if (search) {
    filteredLots = filteredLots.filter((lot) => lot.description.toLowerCase().includes(search));
  }

  return filteredLots;
};

export const getLotsFiltered = createSelector(
  [getLots, getFormValues(Forms.lotsFilterForm)],
  (lots: Lot[], formValue: LotsFilterForm): Lot[] => {
    return filterLots(lots, formValue);
  },
);

export const getLotById = createSelector([getLots, (_state: RootState, id: string) => id], (lots: Lot[], id: string) =>
  lots.find((lot) => lot.id === id),
);

export const getLotCloseouts = createSelector(
  [(state: RootState, id: string) => getLotById(state, id)],
  (lot: Lot | undefined) => {
    const movements = lot && lot.movements ? lot.movements : [];
    return movements.filter((x) => x.movementTypeCode === 4);
  },
);

export const getLotDeaths = createSelector(
  [(state: RootState, id: string) => getLotById(state, id)],
  (lot: Lot | undefined) => {
    const movements = lot && lot.movements ? lot.movements : [];
    return movements.filter((x) => x.movementTypeCode === 3);
  },
);

export const getOrigins = createSelector([getLots], (lots: Lot[]): string[] =>
  Array.from(new Set(lots.map((x) => x.origin || '').filter((x) => x))),
);

export const getLotsByGroupId = createSelector(
  [getLots, (_state: RootState, id: string) => id],
  (lots: Lot[], id: string) => lots.filter((x) => x.groups && x.groups.some((g) => g.groupId === id)),
);

export const getCloseoutHistoryLotsFiltered = (state: RootState) => {
  const lots = state.entities.lots.filter((x) => x.statusCode === 2 || x.statusCode === 4);
  const formValue = {
    ...(getFormValues(Forms.lotsFilterForm)(state) as LotsFilterForm),
    hideClosed: false,
  };
  return filterLots(lots, formValue);
};
